<select #selector>
  <ng-content select="option, optgroup">
  </ng-content>
</select>